import Vue from 'vue'
import App from './App.vue'
import VueMask from 'v-mask'
Vue.use(VueMask);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')

Vue.filter('currency', (val, moeda = false, digits = 2) => {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  });
  const result = formatter.format(val);
  return moeda ? result : result.split('R$ ')[1];
});
